<template>
  <div class="page-text" :style="style">
    <slot></slot>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: [
    "right",
    "left",
    "top",
    "bottom",
    "width",
    "height",
    "pt",
    "pl",
    "mb",
    "bg",
    "bold",
    "bolder",
    "font12",
    "font13",
    "font14",
    "font15",
    "font16",
    "font17",
    "font18",
    "font19",
    "font20",
    "font21",
    "font22",
    "font24",
    "font26",
    "font28",
    "font30",
    "font34",
    "font38",
    "font40",
    "textAlign",
  ],
  computed: {
    style() {
      let style = {};
      _.each(this._props, (value, key) => {
        if (!value) return;
        switch (key) {
          case "right":
            style.right = value;
            break;
          case "top":
            style.top = value;
            break;
          case "left":
            style.left = value;
            break;
          case "bottom":
            style.bottom = value;
            break;
          case "width":
            style.width = value;
            break;
          case "height":
            style.height = value;
            break;
          case "pt":
            style.paddingTop = value;
            break;
          case "pl":
            style.paddingLeft = value;
            break;
          case "mb":
            style.marginBottom = value;
            break;
          case "font12":
          case "font13":
          case "font14":
          case "font15":
          case "font16":
          case "font17":
          case "font18":
          case "font19":
          case "font20":
          case "font21":
          case "font22":
          case "font24":
          case "font26":
          case "font28":
          case "font30":
          case "font34":
          case "font38":
          case "font40":
            style.fontSize = key.replace("font", "") + "px";
            break;
          case "bg":
            style.background = "#fff";
            break;
          case "bold":
            style.fontWeight = "500";
            break;
          case "bolder":
            style.fontWeight = "600";
            break;
          case "textAlign":
            style.textAlign = value;
            break;
        }
      });

      return style;
    },
  },
};
</script>
<style lang="scss" scoped>
.page-text {
  position: absolute;
}
</style>

<style></style>
